import type { SVGProps } from "react";

export default function HierarchyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.84 31.58"
      width={20}
      height={20}
      fill="currentColor"
      {...props}
    >
      <g id="Layer_1-2" data-name="Layer 1-2">
        <g>
          <path d="M4.78,24.77c1.46,0,2.64-1.2,2.64-2.68s-1.18-2.68-2.64-2.68-2.63,1.2-2.63,2.68,1.18,2.68,2.63,2.68ZM9.2,27.12c-.38-.6-1.05-1-1.8-1H2.15c-1.19,0-2.15.98-2.15,2.18v.63c0,.37.29.66.65.66h7.01c.15,0,.27-.11.31-.25.2-.71.61-1.32,1.16-1.77.14-.11.17-.31.07-.46h0ZM16.55,28.11h-5.25c-1.19,0-2.15.98-2.15,2.18v.63c0,.37.29.66.65.66h8.25c.36,0,.65-.3.65-.66v-.63c0-1.21-.96-2.18-2.15-2.18ZM25.7,26.12h-5.25c-.76,0-1.42.4-1.8,1-.1.15-.07.35.07.46.55.45.96,1.06,1.16,1.77.04.15.16.25.31.25h7c.36,0,.65-.3.65-.66v-.63c0-1.21-.96-2.18-2.15-2.18h.01ZM11.29,24.08c0,1.48,1.18,2.68,2.63,2.68s2.64-1.2,2.64-2.68-1.18-2.68-2.64-2.68-2.63,1.2-2.63,2.68ZM20.43,22.09c0,1.48,1.18,2.68,2.63,2.68s2.64-1.2,2.64-2.68-1.18-2.68-2.64-2.68-2.63,1.2-2.63,2.68Z" />
          <path d="M16.74,6.87h-5.46c-1.27,0-2.29,1.04-2.29,2.33v1.29c0,.12.09.21.21.21h9.63c.12,0,.21-.09.21-.21v-1.29c0-1.29-1.03-2.33-2.29-2.33h-.01Z" />
          <path d="M13.98,5.72c1.56,0,2.81-1.28,2.81-2.86s-1.26-2.86-2.81-2.86-2.81,1.28-2.81,2.86,1.26,2.86,2.81,2.86Z" />
          <path d="M14.99,13.71v-.89c0-.55-.44-1-.98-1s-.98.44-.98,1v.89l-4.1,4.16c-.39.39-.39,1.02,0,1.41.19.19.44.29.69.29s.5-.1.69-.29l2.71-2.75v2.38c0,.55.44,1,.98,1s.98-.44.98-1v-2.38l2.71,2.75c.19.19.44.29.69.29s.5-.1.69-.29c.39-.39.39-1.02,0-1.41l-4.1-4.16h.02Z" />
        </g>
      </g>
    </svg>
  );
}
